module.exports = __webpack_public_path__ + "static/img/sec2-cont-sub04.d47ff01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec2-cont-sub04.png
// module id = Vp8W
// module chunks = 0